import { render, staticRenderFns } from "./ArrestTableLegacy.vue?vue&type=template&id=32b60888&scoped=true&"
import script from "./ArrestTableLegacy.vue?vue&type=script&lang=js&"
export * from "./ArrestTableLegacy.vue?vue&type=script&lang=js&"
import style0 from "./ArrestTableLegacy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ArrestTableLegacy.vue?vue&type=style&index=1&id=32b60888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b60888",
  null
  
)

export default component.exports